export const throwError = (code, message) => {
  let instance = new Error(code, message);
  instance.code = code;
  instance.message = message;
  return instance;
};

export function errorHandler(error) {
  console.error(error);
  let result = {};
  switch (error.code) {
    // Authentication errors
    case "auth":
      result.code = error.code;
      result.message = error.message;
      break;
    case "auth/timeout":
      result.code = error.code;
      result.message = "Request timed out. Please try again later";
      break;
    case "auth/invalid-credential":
    case "auth/invalid-verification-code":
    case "auth/invalid-verification-id":
    case "auth/wrong-password":
    case "auth/user-not-found":
      result.code = error.code;
      result.message = "Invalid credentials. Please check your OTP";
      break;
    case "auth/captcha-check-failed":
      result.code = error.code;
      result.message = "Captcha assessment failed. Please try again";
      break;
    case "auth/invalid-phone-number":
    case "auth/missing-phone-number":
      result.code = error.code;
      result.message = "Please enter a valid phone number";
      break;
    case "auth/quota-exceeded":
    case "auth/too-many-requests":
      result.code = error.code;
      result.message = "Usage limit exceeded. Please try again later";
      break;
    case "auth/invalid-user-token":
    case "auth/user-token-expired":
    case "auth/id-token-expired":
    case "auth/id-token-revoked":
      result.code = error.code;
      result.message = "Session expired. Please login";
      break;
    case "auth/network-request-failed":
      result.code = error.code;
      result.message = "Connectivity error. Please try again later";
      break;
    case "auth/requires-recent-login":
      result.code = error.code;
      result.message = "Session duration too long. Please re-login";
      break;
    case "auth/web-storage-unsupported":
      result.code = error.code;
      result.message = "Unsupported web browser";
      break;

    // Input errors
    case "input/image-size-exceeded":
      result.code = error.code;
      result.message = "Image size should be less than 2MB";
      break;
    case "input/file-size-exceeded":
      result.code = error.code;
      result.message = "Document size should be less than 5MB";
      break;
    case "input":
      result.code = `input`;
      result.message = error.message;
      break;

    // Firestore database errors
    case "cancelled":
    case "deadline-exceeded":
    case "not-found":
    case "already-exists":
    case "permission-denied":
    case "resource-exhausted":
    case "failed-precondition":
    case "aborted":
    case "out-of-range":
    case "unimplemented":
    case "internal":
    case "unavailable":
    case "data-loss":
    case "invalid-argument":
    case "search":
      result.code = `database/${error.code}`;
      result.message = "Something went wrong. Please try again later";
      break;

    // Storage errors
    case "object-not-found":
    case "bucket-not-found":
    case "unauthorized":
    case "retry-limit-exceeded":
    case "invalid-event-name":
    case "invalid-url":
    case "server-file-wrong-size":
      result.code = `storage/${error.code}`;
      result.message = "Something went wrong. Please try again later";
      break;
    case "unauthenticated":
      result.code = `storage/${error.code}`;
      result.message = "Session Expired. Please login to continue";
      break;
    case "canceled":
      result.code = `storage/${error.code}`;
      result.message = "Process Cancelled";
      break;

    // API errors
    case "400":
      result.code = `api/${error.code}`;
      result.message = error.message;
      break;

    // Custom errors
    case "custom":
      result.code = error.code;
      result.message = error.message;
      break;

    // Default case
    default:
      if (
        error.code === undefined ||
        !error.code.includes("auth") ||
        !error.code.includes("database") ||
        !error.code.includes("input") ||
        !error.code.includes("storage")
      ) {
        result.code = `unknown/${error.code}`;
      } else {
        result.code = error.code;
      }
      result.message = "Something went wrong. Please try again later";
      break;
  }
  return result;
}
